var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8271",
    "data-name": "Group 8271",
    transform: "translate(-751 -445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    transform: "translate(751 445)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    transform: "translate(762 456)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "smartphone_FILL0_wght300_GRAD0_opsz24",
    d: "M222.195-874.512a2.118,2.118,0,0,1-1.557-.637,2.118,2.118,0,0,1-.637-1.557v-21.1a2.118,2.118,0,0,1,.637-1.557,2.118,2.118,0,0,1,1.557-.637h11.39a2.118,2.118,0,0,1,1.557.637,2.118,2.118,0,0,1,.637,1.557v21.1a2.118,2.118,0,0,1-.637,1.557,2.118,2.118,0,0,1-1.557.637Zm-.373-3.338v1.144a.357.357,0,0,0,.117.257.357.357,0,0,0,.257.117h11.39a.357.357,0,0,0,.257-.117.357.357,0,0,0,.117-.257v-1.144Zm0-1.82h12.137v-15.171H221.821Zm0-16.991h12.137v-1.144a.357.357,0,0,0-.117-.257.357.357,0,0,0-.257-.117h-11.39a.357.357,0,0,0-.257.117.357.357,0,0,0-.117.257Zm0,0v0Zm0,18.812v0Z",
    transform: "translate(563.999 1372.999)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIcon);
export default __webpack_public_path__ + "static/media/otp-icon.62fb10d40033485962ce6e8eaec4fdac.svg";
export { ForwardRef as ReactComponent };